// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tips-info {\n  line-height: 18px;\n  color: #c0c4cc;\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
